import { AppUser } from '../types';
import { PropertyComment } from '../types/propertyComment';

const API_BASE = '/api/property-comments';

const getHeaders = (appUser: AppUser | null): HeadersInit => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (appUser?.id) headers['x-user-id'] = appUser.id;
  if (appUser?.role) headers['x-user-role'] = appUser.role;
  return headers;
};

export const fetchPropertyComments = async (
  propertyCode: string,
  appUser: AppUser | null
): Promise<PropertyComment[]> => {
  const res = await fetch(`${API_BASE}/${encodeURIComponent(propertyCode)}`, {
    method: 'GET',
    headers: getHeaders(appUser),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Error al obtener los comentarios.');
  }
  const data = await res.json();
  return data.comments || [];
};

export const createPropertyComment = async (
  propertyCode: string,
  content: string,
  appUser: AppUser | null
): Promise<PropertyComment> => {
  const res = await fetch(API_BASE, {
    method: 'POST',
    headers: getHeaders(appUser),
    body: JSON.stringify({
      propertyCode,
      content,
      userId: appUser?.id || '',
      userName: appUser?.nombreCompleto || appUser?.username || 'Asesor Comercial',
      userEmail: appUser?.email || '',
      userRole: appUser?.role || '',
    }),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Error al guardar el comentario.');
  }
  const data = await res.json();
  return data.comment;
};

export const updatePropertyComment = async (
  commentId: string,
  content: string,
  appUser: AppUser | null
): Promise<PropertyComment> => {
  const res = await fetch(`${API_BASE}/${encodeURIComponent(commentId)}`, {
    method: 'PUT',
    headers: getHeaders(appUser),
    body: JSON.stringify({
      content,
      userId: appUser?.id || '',
    }),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Error al actualizar el comentario.');
  }
  const data = await res.json();
  return data.comment;
};

export const deletePropertyComment = async (
  commentId: string,
  appUser: AppUser | null
): Promise<void> => {
  const res = await fetch(`${API_BASE}/${encodeURIComponent(commentId)}`, {
    method: 'DELETE',
    headers: getHeaders(appUser),
    body: JSON.stringify({
      userId: appUser?.id || '',
    }),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Error al eliminar el comentario.');
  }
};
